module.exports = __webpack_public_path__ + "static/media/AD.2f0263e0.svg";